export interface VersionStatus {
  ok: boolean;
  minLabel: string;
}

const BROWSER_MIN: Record<string, number> = {
  chrome: 120,
  firefox: 120,
  safari: 16,
  edge: 120,
  mozilla: 120, // Firefox user-agent string prefix
};

const OS_MIN: Record<string, { major: number; minor?: number }> = {
  windows: { major: 10 },
  ios: { major: 15 },
  android: { major: 10 },
  'mac os': { major: 12 },
  macos: { major: 12 },
};

function parseMajorVersion(str: string): number | null {
  const match = str.match(/(\d+)/);
  return match ? parseInt(match[1], 10) : null;
}

export function checkBrowserVersion(browserStr?: string): VersionStatus {
  if (!browserStr?.trim()) return { ok: true, minLabel: '' };

  const lower = browserStr.toLowerCase();

  for (const [name, min] of Object.entries(BROWSER_MIN)) {
    if (lower.includes(name)) {
      const major = parseMajorVersion(browserStr);
      if (major === null) return { ok: true, minLabel: '' };

      const displayName = name === 'mozilla' ? 'Firefox' : name.charAt(0).toUpperCase() + name.slice(1);
      return {
        ok: major >= min,
        minLabel: `${displayName} ${min}`,
      };
    }
  }

  return { ok: true, minLabel: '' };
}

export function checkOsVersion(osStr?: string): VersionStatus {
  if (!osStr?.trim()) return { ok: true, minLabel: '' };

  const lower = osStr.toLowerCase();

  for (const [name, min] of Object.entries(OS_MIN)) {
    if (lower.startsWith(name)) {
      const major = parseMajorVersion(osStr);
      if (major === null) return { ok: true, minLabel: '' };

      const displayName =
        name === 'mac os' || name === 'macos' ? 'macOS' : name.charAt(0).toUpperCase() + name.slice(1);
      const minDisplay = min.minor !== undefined ? `${min.major}.${min.minor}` : `${min.major}`;
      return {
        ok: major >= min.major,
        minLabel: `${displayName} ${minDisplay}`,
      };
    }
  }

  return { ok: true, minLabel: '' };
}
